/**
 * Vinted-reviews-new-tab.js
 * 
 * Makes the Vinted reviews link open in a new tab
 * Add this file to your Shopify theme under: 
 * Snippets/vinted-reviews-new-tab.js
 */

(function() {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Find the specific Vinted reviews link
    const vintedLink = document.querySelector('a.button.button--secondary[href="https://www.vinted.com/member/41289644"]');
    
    // If found, modify it to open in a new tab
    if (vintedLink) {
      vintedLink.setAttribute('target', '_blank');
      vintedLink.setAttribute('rel', 'noopener');
      console.log('Vinted reviews link modified to open in new tab');
    }
  });
  
  // Also listen for Shopify's page:load event for compatibility with their AJAX navigation
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(function() {
        const vintedLink = document.querySelector('a.button.button--secondary[href="https://www.vinted.com/member/41289644"]');
        if (vintedLink) {
          vintedLink.setAttribute('target', '_blank');
          vintedLink.setAttribute('rel', 'noopener');
        }
      }, 100);
    });
  }
})();